import { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

import { IconColor, useIconColor } from './useIconColor';

interface SVGRProps {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
  color?: IconColor;
}

export const Basket = ({
  title,
  titleId,
  size = 2,
  color,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & SVGRProps) => {
  const { fill, svgNode } = useIconColor(color);
  return (
    <svg
      viewBox="0 0 16 16"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.2 6.79998H4.8V5.59998H11.2V6.79998ZM16 6.82498V9.77498C16 10.4 15.6 10.975 15.025 11.225L12.7 12.25L13.1 8.79998H12.3L11.675 14.05C11.675 14.175 11.55 14.4 11.3 14.4C11.175 14.4 11.075 14.375 11 14.3L9.65 12.85L8.275 14.3C8.2 14.375 8.1 14.4 8 14.4C7.875 14.4 7.775 14.375 7.7 14.3L6.35 12.85L4.975 14.3C4.9 14.375 4.8 14.4 4.675 14.4C4.4 14.4 4.3 14.175 4.3 14.05L3.675 8.79998H2.875L3.275 12.25L0.95 11.225C0.375 10.975 0 10.4 0 9.77498V6.82498C0 5.79998 2.625 1.59998 8 1.59998C13.425 1.59998 16 5.84998 16 6.82498ZM5.65 8.79998H4.475L4.6 9.69998L5.65 8.79998ZM5.775 12.275L4.75 11.2L4.975 13.125L5.775 12.275ZM6.325 11.7L7.425 10.55L6.275 9.32498L5.075 10.35L6.325 11.7ZM8 9.94998L9.075 8.79998H6.9L8 9.94998ZM9.075 12.275L8 11.125L6.9 12.275L8 13.425L9.075 12.275ZM9.625 11.7L10.875 10.35L9.675 9.32498L8.525 10.55L9.625 11.7ZM11.225 11.2L10.2 12.275L11 13.125L11.225 11.2ZM11.5 8.79998H10.325L11.375 9.72498L11.5 8.79998ZM13.6 6.99998C13.6 6.89998 13.5 6.79998 13.4 6.79998H12V5.59998C12 5.17498 11.625 4.79998 11.2 4.79998H4.8C4.35 4.79998 4 5.17498 4 5.59998V6.79998H2.6C2.475 6.79998 2.4 6.89998 2.4 6.99998V7.39998C2.4 7.52498 2.475 7.59998 2.6 7.59998H13.4C13.5 7.59998 13.6 7.52498 13.6 7.39998V6.99998Z"
        fill={fill}
      />
      {svgNode}
    </svg>
  );
};
